/**
 * Bulk User API endpoints
 */
import axiosClient from './axiosClient';

export interface BulkUserItem {
  username: string;
  email: string;
  first_name: string;
  last_name: string;
  password: string;
  role?: string;
  organization_id?: string;
  display_name?: string;
  bio?: string;
  timezone?: string;
  language?: string;
}

export interface BulkUserUploadResponse {
  total: number;
  successful: number;
  failed: number;
  errors: Array<{
    row: number;
    email: string;
    error: string;
  }>;
}

export const bulkUserAPI = {
  /**
   * Bulk create users from JSON array
   */
  createBulkUsers: async (users: BulkUserItem[]): Promise<BulkUserUploadResponse> => {
    const response = await axiosClient.post<BulkUserUploadResponse>(
      '/users/bulk/bulk',
      { users }
    );
    return response.data;
  },
};

